<template>
  <div class="panel_settlement">
    <div style="padding-top: 7px">
      <span class="priceItem">
        <span class="label">总计：</span>
        <span class="price">￥{{ money }}</span>
      </span>
      <span class="priceItem">
        <span class="label">优惠金额：</span>
        <span class="price">￥{{
          $public.jian(money, $public.jian(activityMoney, discountMoney))
        }}</span>
      </span>
      <span class="priceItem">
        <span class="label">会员价：</span>
        <span class="price">￥{{ huiyuanMoney }}</span>
      </span>
      <span class="priceItem" style="font-size: 12px" v-if="curDiscountCard && curDiscountCard._id">
        {{ curDiscountCard.coupon_name }}
        <!-- ({{ curDiscountCard.category_info.name }}) -->
        <span v-if="curDiscountCard.activity_type === 1">
          满{{ curDiscountCard.money_top }}元可用
        </span>
        <span v-if="curDiscountCard.activity_type === 2">
          满{{ curDiscountCard.rebate_top }}元可用，
          <span v-if="curDiscountCard.rebate_limit > 0">最高抵扣{{ curDiscountCard.rebate_limit }}元</span>
          <span v-else></span>
        </span>
        <span style="color: #1890ff; cursor: pointer" @click="delDiscountCard">删除</span>
      </span>
    </div>
    <div>

      <el-button style="width: 80px" type="warning" plain @click="openDiscountCard" size="max"
        v-if="$public.isNull(curDiscountCard)">
        优惠券
      </el-button>
      <el-button style="width: 80px" type="warning" plain @click="openBeizhu" size="max">备注</el-button>
      <!-- <el-button
        style="width: 100px"
        type="warning"
        plain
        @click="submitOrder"
        size="max"
        >生成订单</el-button
      > -->
      <el-button
        v-if="userInfo.club_card && userInfo.club_card.is_valid == false && userInfo.card_info.user_yue > 0 && showVip == true"
        type="primary" :disabled="huiyuanMoney > userInfo.card_info.user_yue || money == vipMoney"
        @click="submitOrderAndSettlement(1)" size="max">会员价结算￥{{ huiyuanMoney }}</el-button>
      <el-button type="warning" @click="submitOrderAndSettlement" size="max">结算￥{{ $public.jian(activityMoney,
          discountMoney) }}</el-button>
    </div>
    <!-- 备注弹窗 -->
    <div v-if="drawerRemark_state">
      <drawerRemark :type="'ximei'" @submit="submit_drawerRemark"></drawerRemark>
    </div>
    <!-- 结算 -->
    <div v-if="dialogSettlement_state">
      <dialogSettlement :orderId="curOrder.orderNum" @submit="submit_dialogSettlement"></dialogSettlement>
    </div>
    <!-- 优惠券 -->
    <div v-show="drawerDiscountCard_state">
      <drawerDiscountCard :userId="userInfo._id" :state="drawerDiscountCard_state" :type="2"
        :money="$public.jian(activityMoney, discountMoney)" @submit="submit_drawerDiscountCard"></drawerDiscountCard>
    </div>
  </div>
</template>
<script>
import drawerDiscountCard from "../drawer/discountximeiCard.vue";
import drawerRemark from "../drawer/remark.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
// import del from "../../../../util/del.js"
export default {
  components: { drawerDiscountCard, drawerRemark, dialogSettlement },
  data() {
    return {
      // 备注
      drawerRemark_state: false,
      // 结算
      dialogSettlement_state: false,
      curOrder: {},
      //
      // o:null,

      // 优惠券
      drawerDiscountCard_state: false,
      // 是否直接结算
      direct: false,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    addParams() {
      return this.$store.state.ximei.addParams;
    },
    money() {
      return this.$store.state.ximei.money;
    },
    showVip() {
      return this.$store.state.ximei.showVip;
    },
    huiyuanMoney() {
      return this.$store.state.ximei.huiyuanMoney;
    },
    activityMoney() {
      return this.$store.state.ximei.activityMoney;
    },
    discountMoney() {
      return this.$store.state.ximei.discountMoney;
    },
    remark() {
      return this.$store.state.ximei.remark;
    },
    curDiscountCard() {
      return this.$store.state.ximei.curDiscountCard;
    },
  },
  mounted() {
    // this.o = new del();
  },
  methods: {
    // 结算
    submitOrderAndSettlement(type) {
      this.direct = true;
      this.submitOrder(type);
    },
    // 创建订单
    submitOrder(type) {
      let petList = [];
      let obj = this.addParams;
      for (let i = 0; i < obj.length; i++) {
        // if(this.$public.isNull(obj[i].cageId)){
        // 	this.$message({
        // 		message: '请选择洗美间',
        // 		type: 'error'
        // 	});
        // 	return ;
        // }
        console.log(obj[i], 'objobjobjobj');
        if (this.$public.isNull(obj[i].petId)) {
          continue;
        }
        if (this.$public.isNull(obj[i].tableData)) {
          this.$message({
            message: "请选择洗美服务",
            type: "error",
          });
          return;
        } else {
          let serviceList = [];

          for (let a = 0; a < obj[i].tableData.length; a++) {
            if (this.$public.isNull(obj[i].tableData[a].salesMans)) {
              this.$message({
                message: "请完善销售人员",
                type: "error",
              });
              return;
            }
            let salesMans = [];
            for (let b = 0; b < obj[i].tableData[a].salesMans.length; b++) {
              salesMans.push({
                userId: obj[i].tableData[a].salesMans[b].split(",")[0],
                userName: obj[i].tableData[a].salesMans[b].split(",")[1],
              });
            }
            let activityId = "";
            let activityName = "";
            let activityType = 0;
            if (obj[i].tableData[a].couponId) {
              (activityType = 5),
                (activityId = obj[i].tableData[a].couponItem._no);
              activityName = obj[i].tableData[a].couponItem.coupon_name;
            } else if (obj[i].tableData[a].activityId) {
              (activityType = 1),
                (activityId = obj[i].tableData[a].activityItem._id);
              activityName = obj[i].tableData[a].activityItem.name;
            } else if (obj[i].tableData[a].cardId) {
              activityType = 2;
            } else {
              activityId = "";
              activityName = "";
            }

            serviceList.push({
              needContract: obj[i].tableData[a].need_contract,
              cardNum: obj[i].tableData[a].cardId
                ? obj[i].tableData[a].cardItem.card_number
                : "",
              cardName: obj[i].tableData[a].cardId
                ? obj[i].tableData[a].cardItem.card_name
                : "",
              salesMans: salesMans,
              goodsId: obj[i].tableData[a].serviceId,
              goodsName: obj[i].tableData[a].title,
              goodsType: 2,
              brand: obj[i].tableData[a].brand,
              categoryId: obj[i].tableData[a].category_info._id,
              categoryName: obj[i].tableData[a].category_info.name,
              skus: obj[i].tableData[a].skuItem.service_objectId,
              skuValue:
                (obj[i].tableData[a].skuItem.extend_attr
                  ? obj[i].tableData[a].skuItem.extend_attr + " "
                  : "") + obj[i].tableData[a].skuItem.service_objectName,
              unitId: "",
              unit: obj[i].tableData[a].skuItem.frequency_text,
              outUnit: obj[i].tableData[a].skuItem.frequency_text,
              vipPrice: obj[i].tableData[a].skuItem.mprice,
              originalPrice: obj[i].tableData[a].cardId
                ? obj[i].tableData[a].cardItem.unit_price
                : obj[i].tableData[a].skuItem.originalPrice,
              price: this.curDiscountCard? obj[i].tableData[a].skuItem.originalPrice : obj[i].tableData[a].skuItem.price,
              num: 1,
              activityType: activityType,
              activityId: activityId,
              activityName: activityName,
              payType: obj[i].tableData[a].activityId
                ? obj[i].tableData[a].activityItem.pay_type
                : "",
              totalMoney: 0,
              joinCommission: obj[i].tableData[a].join_commission,
              isNeedCode: false,
              buyBack: obj[i].tableData[a].buyBack,
            });
          }
          petList.push({
            petId: obj[i].petItem._id,
            petName: obj[i].petItem.nick_name,
            hsPet: obj[i].petItem.hs_pet,
            chip: obj[i].petItem.eprom_no,
            classType: obj[i].petItem.apply_type.value,
            className: obj[i].petItem.apply_type.title,
            typeName: obj[i].petItem.category_info.name,
            sex: obj[i].petItem.pet_sex,
            birthDay: obj[i].petItem.bron_date,
            weight: obj[i].weight,
            services: serviceList,
            remark: obj[i].remark,

          });
        }
      }
      let petsId = [];
      for (let i = 0; i < petList.length; i++) {
        if (petsId.indexOf(petList[i].petId) > -1) {
          this.$message({
            message: "宠物重复，每只宠物只能有一个洗美计划",
            type: "error",
          });
          return;
        }
        petsId.push(petList[i].petId);
      }
      /////////////////////////////////         洗美服务活动没有赠品 from洋洋
      let params = {
        memberId: this.userInfo._id,
        memberName: this.userInfo.basic_info.nick_name,
        memberMobile: this.userInfo.basic_info.user_mobile,
        memberGrades: this.userInfo.club_card.surplus_day,
        couponNo: this.curDiscountCard ? this.curDiscountCard._no : "",
        remark: this.remark,
        pets: petList,
        useVipPrice: type == 1 ? true : false,
      };
      console.log("params洗美提交--------------", params);
      let loading = this.$loading();
      this.$http.post("/api/WashBeauty/Insert", params).then((res) => {
        loading.close();
        console.log(res, "res");
        console.log(this.direct, "direct");
        if (res.code == 0) {
          if (this.direct) {
            this.curOrder = res.data;
            this.dialogSettlement_state = true;
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$store.dispatch("mendian/get_unPayOrderList");
            this.$store.dispatch("mendian/getJiedaiLength");
            this.$store.commit("ximei/set_type", "list");
          }
        }
      });
    },
    // 优惠券
    openDiscountCard() {
      let obj = this.addParams;
      let hasActivity = false;
      let hasCoupon = false;
      let hasCard = false;
      for (let i = 0; i < obj.length; i++) {
        for (let a = 0; a < obj[i].tableData.length; a++) {
          if (!this.$public.isNull(obj[i].tableData[a].activityId)) {
            hasActivity = true;
          }
          if (!this.$public.isNull(obj[i].tableData[a].cardId)) {
            hasCard = true;
          }
          if (!this.$public.isNull(obj[i].tableData[a].couponId)) {
            hasCoupon = true;
          }
        }
      }
      // hasCard
      if (hasCard === false) {
        this.drawerDiscountCard_state = true;
      } else {
        this.$message({
          message: "使用礼品卡后不可使用优惠券",
          type: "error",
        });
        this.drawerDiscountCard_state = false;
        return;
      }
      if (hasActivity === false) {
        this.drawerDiscountCard_state = true;
      } else {
        this.$message({
          message: "参与活动后不可使用优惠券",
          type: "error",
        });
        this.drawerDiscountCard_state = false;
        return;
      }
      if (hasCoupon === false) {
        this.drawerDiscountCard_state = true;
      } else {
        this.$message({
          message: "参与优惠后不可使用优惠券",
          type: "error",
        });
        this.drawerDiscountCard_state = false;
        return;
      }
    },
    submit_drawerDiscountCard(obj) {
      console.log(this.activityMoney, obj.newMoney, 'obj');

      if (obj.type === "submit") {
        this.$store.commit(
          "ximei/set_discountMoney",
          this.$public.jian(this.activityMoney, obj.newMoney)
        );
        this.$store.commit("ximei/set_curDiscountCard", obj.card);
        this.drawerDiscountCard_state = false;
      } else {
        this.drawerDiscountCard_state = false;
      }
    },
    delDiscountCard() {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("ximei/set_discountMoney", 0);
        this.$store.commit("ximei/set_curDiscountCard", null);
      });
    },
    // 结算
    submit_dialogSettlement(a) {
      this.dialogSettlement_state = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
      }
      this.$store.commit("ximei/set_type", "list");
    },
    // 备注
    openBeizhu() {
      this.drawerRemark_state = true;
    },
    submit_drawerRemark() {
      this.drawerRemark_state = false;
    },
  },
};
</script>
<style scoped lang="scss">
.panel_settlement {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0 -3px 3px 0px #f5f5f5;

  .priceItem {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;

    .label {
      font-size: 14px;
      color: $fontColor;
    }

    .price {
      font-size: 20px;
      color: $fontColor;
    }
  }
}
</style>
